/* MaxiPlast USA – theme behaviour (Propuesta v1) */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var lastFocus = null;

  function money(c) { return '$' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function unit(c, u) { var v = c / u / 100; return '$' + (v < 0.0995 ? v.toFixed(3) : v.toFixed(2)); }
  function nf(n) { return Number(n).toLocaleString('en-US'); }
  function lock(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }
  function toast(msg) { var t = $('#mpToast'); if (!t) return; t.textContent = msg; t.hidden = false; clearTimeout(t._t); t._t = setTimeout(function () { t.hidden = true; }, 3200); }
  function closeDd() { $$('[data-dd]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); var m = document.getElementById(b.getAttribute('aria-controls')); if (m) m.hidden = true; }); }
  function closeAll() {
    var d = $('#mpDrawer'), n = $('#mpNav'), s = $('#mpScrim');
    if (d) d.hidden = true; if (n) n.hidden = true; if (s) s.hidden = true; lock(false);
    if (lastFocus && lastFocus.focus) { lastFocus.focus(); } lastFocus = null;
  }

  /* ---------- cart ---------- */
  function setCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; }); }
  function paintDrawer(html) {
    if (!html) return;
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var inner = tmp.querySelector('#mpDrawerInner'), cur = $('#mpDrawerInner');
    if (inner && cur) { cur.parentNode.replaceChild(inner, cur); setCount(parseInt(inner.getAttribute('data-count'), 10) || 0); }
  }
  function openDrawer() {
    var d = $('#mpDrawer'); if (!d) { location.href = ROOT + 'cart'; return; }
    lastFocus = document.activeElement; d.hidden = false;
    var s = $('#mpScrim'); if (s) s.hidden = false; lock(true);
    var c = $('[data-close]', d); if (c) c.focus();
  }
  function post(url, body) {
    return fetch(ROOT + url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong. Please try again.'); return j; }); });
  }
  function add(items, btn) {
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    return post('cart/add.js', { items: items, sections: 'mp-cart-drawer' })
      .then(function (j) { if (j.sections) paintDrawer(j.sections['mp-cart-drawer']); openDrawer(); })
      .catch(function (e) { toast(e.message); })
      .then(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  }
  function change(line, q) {
    return post('cart/change.js', { line: line, quantity: Math.max(0, q), sections: 'mp-cart-drawer' })
      .then(function (j) { paintDrawer(j.sections && j.sections['mp-cart-drawer']); var c = $('#mpDrawer [data-close]'); if (c) c.focus(); })
      .catch(function (e) { toast(e.message); });
  }

  /* ---------- product form ---------- */
  function pformUpdate(f) {
    if (!f) return;
    var qi = $('[name=quantity]', f); var n = Math.max(1, parseInt(qi.value, 10) || 1); qi.value = n;
    var price = parseInt(f.getAttribute('data-price'), 10) || 0, units = parseInt(f.getAttribute('data-units'), 10) || 0;
    var out = $('[data-total]', f.closest('.pbox') || f);
    if (out) out.innerHTML = n + ' ' + (n === 1 ? 'case' : 'cases') + (units ? ' = <b>' + nf(n * units) + ' units</b>' : '') + ' · <b>' + money(n * price) + '</b>' + (n >= 10 ? ' · qualifies for truck delivery in South Florida' : '');
  }
  function variantChange(sel) {
    var f = sel.form, o = sel.options[sel.selectedIndex]; if (!o) return;
    var price = parseInt(o.getAttribute('data-price'), 10), units = parseInt(f.getAttribute('data-units'), 10) || 0;
    f.setAttribute('data-price', price);
    var box = f.closest('.pinfo') || document;
    $$('[data-price-out]', box).forEach(function (el) { el.textContent = money(price); });
    $$('[data-unit-out]', box).forEach(function (el) { if (units) el.textContent = unit(price, units); });
    $$('[data-sku-out]', box).forEach(function (el) { el.textContent = o.getAttribute('data-sku') || ''; });
    var b = $('[type=submit]', f), av = o.getAttribute('data-avail') === 'true';
    if (b) { b.disabled = !av; var l = $('.lbl', b); if (l) l.textContent = av ? 'Add to cart' : 'Sold out'; }
    if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', o.value); history.replaceState({}, '', u); }
    pformUpdate(f);
  }

  /* ---------- clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target, el;
    if ((el = t.closest('[data-add]'))) { e.preventDefault(); add([{ id: +el.getAttribute('data-add'), quantity: +(el.getAttribute('data-qty') || 1) }], el); return; }
    if ((el = t.closest('[data-addset]'))) { e.preventDefault(); add(el.getAttribute('data-addset').split(',').map(function (id) { return { id: +id, quantity: 1 }; }), el); return; }
    if ((el = t.closest('[data-line]'))) { e.preventDefault(); change(+el.getAttribute('data-line'), +el.getAttribute('data-q')); return; }
    if ((el = t.closest('[data-open-cart]'))) { e.preventDefault(); openDrawer(); return; }
    if ((el = t.closest('[data-open-nav]'))) { var n = $('#mpNav'); if (n) { lastFocus = el; n.hidden = false; $('#mpScrim').hidden = false; lock(true); var c = $('[data-close]', n); if (c) c.focus(); } return; }
    if (t.closest('[data-close]') || t.id === 'mpScrim') { closeAll(); return; }
    if ((el = t.closest('[data-dd]'))) { var m = document.getElementById(el.getAttribute('aria-controls')); var open = m && m.hidden; closeDd(); if (m) { m.hidden = !open; el.setAttribute('aria-expanded', String(!!open)); } return; }
    if (!t.closest('.dd')) closeDd();
    if (!t.closest('.s-search')) closeSugg();
    if ((el = t.closest('[data-step]'))) { var f = el.closest('form'); var qi = $('[name=quantity]', f); qi.value = Math.max(1, (parseInt(qi.value, 10) || 1) + (+el.getAttribute('data-step'))); pformUpdate(f); return; }
    if ((el = t.closest('[data-img]'))) {
      var g = el.closest('.gal'), i = el.getAttribute('data-img');
      $$('[data-img]', g).forEach(function (b) { b.setAttribute('aria-pressed', String(b === el)); });
      $$('[data-pane]', g).forEach(function (p) { p.hidden = p.getAttribute('data-pane') !== i; });
      var cap = $('.gal__cap', g); if (cap) cap.textContent = el.getAttribute('data-cap') || '';
      return;
    }
    if ((el = t.closest('[data-ftoggle]'))) { var fp = document.getElementById(el.getAttribute('aria-controls')); if (fp) { var o = fp.classList.toggle('open'); el.setAttribute('aria-expanded', String(o)); } return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeAll(); closeDd(); closeSugg(); }
    var a = document.activeElement, tag = a && a.tagName;
    if (e.key === '/' && tag !== 'INPUT' && tag !== 'TEXTAREA' && tag !== 'SELECT' && !(a && a.isContentEditable)) { var q = $('#mpQ'); if (q) { e.preventDefault(); q.focus(); } }
  });

  /* ---------- forms ---------- */
  function goFilters(f) {
    var p = new URLSearchParams();
    new FormData(f).forEach(function (v, k) { if (v !== '') p.append(k, v); });
    location.href = f.getAttribute('action').split('?')[0] + (p.toString() ? '?' + p.toString() : '');
  }
  document.addEventListener('change', function (e) {
    var t = e.target, f = t.form;
    if (f && f.id === 'mpFilters' && t.type !== 'number') { goFilters(f); return; }
    if (t.matches && t.matches('.mp-pform select[name=id]')) { variantChange(t); return; }
    if (t.matches && t.matches('.mp-pform [name=quantity]')) pformUpdate(f);
  });
  document.addEventListener('input', function (e) { if (e.target.matches && e.target.matches('.mp-pform [name=quantity]')) pformUpdate(e.target.form); });
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.classList && f.classList.contains('mp-pform')) { e.preventDefault(); add([{ id: +$('[name=id]', f).value, quantity: Math.max(1, +$('[name=quantity]', f).value || 1) }], $('[type=submit]', f)); return; }
    if (f.id === 'mpFilters') { e.preventDefault(); goFilters(f); }
  });

  /* ---------- predictive search ---------- */
  var q = $('#mpQ'), sg = $('#mpSugg'), timer, ctrl;
  function closeSugg() { if (sg) { sg.hidden = true; if (q) q.setAttribute('aria-expanded', 'false'); } }
  if (q && sg) {
    q.addEventListener('input', function () {
      clearTimeout(timer); var v = q.value.trim();
      if (v.length < 2) { closeSugg(); return; }
      timer = setTimeout(function () {
        if (ctrl) ctrl.abort(); ctrl = window.AbortController ? new AbortController() : null;
        var url = ROOT + 'search/suggest?q=' + encodeURIComponent(v) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.sku,variants.title,tag&section_id=mp-predictive';
        fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.text(); }).then(function (h) {
          var tmp = document.createElement('div'); tmp.innerHTML = h; var i = tmp.querySelector('#mpSuggInner');
          sg.innerHTML = i ? i.innerHTML : ''; sg.hidden = !i; q.setAttribute('aria-expanded', String(!!i));
        }).catch(function () {});
      }, 180);
    });
  }

  $$('.mp-pform').forEach(pformUpdate);
})();